import { commonLang } from '@umu/ukit-lang';
/**
 * @description tabs
 * @author duanjun
 * @date
 */

// 考虑到未来的扩张，以及让list更具复用性，代码的收敛，推荐使用, 虽然目前list功能更多是个容器的作用

/*usage
let data = [{"name": 4}, {"name": 5}];
<List dataList={data} renderItem={(props) => { return <div>{props.name}</div>}}></List>
*/
import React, { Children, PureComponent, ReactElement, ReactNode } from 'react';
import Loading from './../loading/loading';
import './list.scss';
import LoadMore from './loadMore';

interface IItemData {
    [propName: string]: any;
}

interface IListProps {
    dataList: IItemData[];
    isLoading?: boolean;
    className?: string;
    itemClassName?: string;
    totalPageNum?: number;
    currentPage?: number;
    itemKey?: string | null;
    getkey?: (item: IItemData) => React.Key;
    load?(): void;
    renderItem(itemProps: IItemData, index: number): JSX.Element;
}

interface IListItemProps {
    itemClassName?: string;
    children: JSX.Element;
}

function ListItem(props: IListItemProps) {
    let itemClassName = props.itemClassName || '';
    itemClassName = ['list-item', itemClassName].join(' ');
    return <li className={itemClassName}>{props.children}</li>;
}

interface IListBlankProps {
    children?: JSX.Element | null;
}

function ListBlank(props: IListBlankProps) {
    return (
        <div className="list-blank">
            {props.children || <p className="list-blank-text">{commonLang('暂无数据')}</p>}
        </div>
    );
}

interface IListLoadingProps {
    children?: JSX.Element;
}

function ListLoading(props: IListLoadingProps) {
    return props.children || <Loading />;
}

class List extends PureComponent<IListProps, {}> {
    constructor(props: IListProps) {
        super(props);
        this.renderList = this.renderList.bind(this);
        this.renderLoadingAndBlank = this.renderLoadingAndBlank.bind(this);
        this.renderLoadMore = this.renderLoadMore.bind(this);
    }

    // TODO
    public validateChildComponents(children: ReactNode) {
        // 里边只能放ListBlank, listLoading
        let listBlankCount = 0;
        let listLoadingCount = 0;

        Children.map(children, (child: ReactNode, _index) => {
            const element = child as ReactElement<any>;
            if (element.type === ListBlank) {
                listBlankCount += 1;
            } else if (element.type === ListLoading) {
                listLoadingCount += 1;
            } else {
                throw new Error('非法的list子组件');
            }
        });

        if (listBlankCount > 1 || listLoadingCount > 1) {
            throw new Error('ListBlank 或者 ListLoading 同一类型仅且只能有一个');
        }
        return true;
    }

    public renderItem(_itemProps: IListProps, index: number) {
        return <span key={index}>item:{index}</span>;
    }

    public renderList() {
        const props = this.props;

        const dataList = props.dataList || [];
        const keyProp = props.hasOwnProperty('itemKey') ? props.itemKey : null;
        const renderItem = props.renderItem || this.renderItem;
        if (dataList.length) {
            const listChildren = dataList.map((listItemData: IItemData, index) => {
                let key: React.Key = index;
                if (keyProp) {
                    key = listItemData[keyProp];
                } else if (props.getkey) {
                    key = props.getkey(listItemData);
                }

                return (
                    <ListItem key={key} itemClassName={props.itemClassName}>
                        {renderItem(listItemData, index)}
                    </ListItem>
                );
            });

            let className = props.className || '';
            className = ['list', className].join(' ');
            return <ul className={className}>{listChildren}</ul>;
        } else {
            return null;
        }
    }

    public renderLoadingAndBlank() {
        const props = this.props;
        const dataList = props.dataList || [];
        const isLoading = props.isLoading;
        let children = props.children;

        children = Children.map(children, (child: ReactNode) => {
            const element = child as ReactElement<any>;
            if (element.type === ListBlank) {
                if (isLoading || dataList.length) {
                    return null;
                }
            } else if (element.type === ListLoading) {
                if (!isLoading) {
                    return null;
                }
            }
            return child;
        });
        return children;
    }

    public renderLoadMore() {
        const { totalPageNum, isLoading, currentPage, load } = this.props;
        if (!isLoading && totalPageNum && currentPage && load) {
            return <LoadMore totalPageNum={+totalPageNum} currentPage={currentPage} load={load} />;
        } else {
            return null;
        }
    }

    public render() {
        // 先检测子组件
        // TODO
        if (!this.validateChildComponents(this.props.children)) {
            return null;
        }

        return (
            <div className="list-panel">
                {this.renderList()}
                {this.renderLoadingAndBlank()}
                {this.renderLoadMore()}
            </div>
        );
    }
}

export { List, ListBlank, ListLoading };
